export const addInspectlet = (inspectletKey: number, email: string) => {
  var insp_ab_loader = true // set to false to disable A/B optimized loader
  // @ts-ignore
  window.__insp = window.__insp || []
  // @ts-ignore
  __insp.push(['wid', inspectletKey])
  // @ts-ignore
  __insp.push(['identify', email])

  var ldinsp = function () {
    // @ts-ignore
    if (typeof window.__inspld != 'undefined') return
    // @ts-ignore
    window.__inspld = 1
    var insp = document.createElement('script')
    insp.type = 'text/javascript'
    insp.async = true
    insp.id = 'inspsync'
    insp.src =
      ('https:' == document.location.protocol ? 'https' : 'http') +
      '://cdn.inspectlet.com/inspectlet.js?wid=' +
      inspectletKey +
      '&r=' +
      Math.floor(new Date().getTime() / 3600000)
    const x = document.getElementsByTagName('script')[0]
    x.parentNode.insertBefore(insp, x)
    if (typeof insp_ab_loader != 'undefined' && insp_ab_loader) {
      var adlt = function () {
        var e = document.getElementById('insp_abl')
        if (e) {
          e.parentNode.removeChild(e)
          // @ts-ignore
          __insp.push(['ab_timeout'])
        }
      }
      var adlc = 'body{ visibility: hidden !important; }'
      // @ts-ignore
      var adln = typeof insp_ab_loader_t != 'undefined' ? insp_ab_loader_t : 800
      insp.onerror = adlt
      var abti = setTimeout(adlt, adln)
      // @ts-ignore
      window.__insp_abt = abti
      var abl = document.createElement('style')
      abl.id = 'insp_abl'
      abl.type = 'text/css'
      // @ts-ignore
      if (abl.styleSheet) abl.styleSheet.cssText = adlc
      else abl.appendChild(document.createTextNode(adlc))
      document.head.appendChild(abl)
    }
  }

  setTimeout(ldinsp, 0)
}
